import ko from 'knockout';
import _ from 'underscore';
import { getBulkApiErrors } from '@bingads-webui-component-legacy/api-errors-campaign/index';
import targetConstants from '@bingads-webui-campaign-legacy/base-targets/viewmodel/targetConstants';
import helper from '@bingads-webui-campaign-legacy/base-targets/util/helper';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');
const i18nApiError = window.globalLegacyI18n.get('component/i18n/loader!component/api-errors-campaign');

ko.subscribable.fn.subscribeChanged = (callback, observable) => {
  let previousValue;

  observable.subscribe((_previousValue) => {
    previousValue = _previousValue;
  }, undefined, 'beforeChange');
  observable.subscribe((latestValue) => {
    callback(latestValue, previousValue);
  });
};

class Device {
  constructor(device, viewmodel) {
    this.key = `DeviceType${device.key}`;
    this.name = device.key;
    this.displayName = device.name;
    this.bidAdjustmentOptions = targetConstants.bidAdjustmentOptions;
    this.error = ko.observable('');
    this.expandLinkText = ko.observable(i18n.get('EditLink'));
    this.readonlyBid = ko.computed(() => (viewmodel.level === 'adgroup' && viewmodel.useCampaignSettings()) ||
      (!viewmodel.options.showLevelToggle && viewmodel.options.isParentView));
    this.selectedBidAdjustmentOption = ko.observable(
      helper.getSelectedBidAdjustmentOption(this.key, viewmodel.options, viewmodel.level, viewmodel.useCampaignSettings()),
    );
    this.selectedBidAdjustmentOption.subscribe(() => {
      viewmodel._validateBid(this);
    }, this);
    this.bidAdjustmentValue = ko.observable(
      helper.getBidAdjustmentValue(this.key, viewmodel.options, viewmodel.level, viewmodel.useCampaignSettings()),
    );
    this.bidAdjustmentValue.subscribe((value) => {
      this.bidAdjustmentValue(value);
      viewmodel._validateBid(this);
    }, this);
    this.originalCampaignBidAdjustmentValue = viewmodel.options[`${this.key}CampaignBidAdjustment`];
    this.originalAdgroupBidAdjustmentValue = viewmodel.options[`${this.key}AdgroupBidAdjustment`];
    this.CampaignBidId = viewmodel.options[`${this.key}CampaignBidId`];
    this.AdgroupBidId = viewmodel.options[`${this.key}AdgroupBidId`];
    this.selectedOsCount = ko.observable(0);
    this.isSelected = ko.observable();
    this.isSelected.subscribeChanged((newValue, oldValue) => {
      if (!oldValue && newValue) {
        viewmodel.selectedDeviceCount++;
      } else if (oldValue && !newValue) {
        viewmodel.selectedDeviceCount--;
      }
    }, this.isSelected);
    this.isSelected(viewmodel._shouldSelectTarget(this.key));
    this.onClick = () => {
      if (!this.isSelected() && viewmodel.selectedDeviceCount === 0) {
        this.isSelected(true);
      } else {
        _.each(this.operatingSystems, (os) => {
          os.isSelected(this.isSelected());
        });
      }
      viewmodel._countValidatedDevices();
      return true;
    };
    this.changeText = (currentDevice, event) => {
      if (event.currentTarget.className.indexOf('collapsed') > -1) {
        currentDevice.expandLinkText(i18n.get('EditLink_Hide'));
      } else {
        currentDevice.expandLinkText(i18n.get('EditLink'));
      }
    };
    this.operatingSystems = _.map(device.operatingSystems, (osName) => {
      const isSelected = ko.observable();

      isSelected.subscribeChanged((newValue, oldValue) => {
        if (!oldValue && newValue) {
          this.isSelected(true);
          this.selectedOsCount(this.selectedOsCount() + 1);
        } else if (oldValue && !newValue) {
          this.selectedOsCount(this.selectedOsCount() - 1);
        }
      }, isSelected);

      isSelected(viewmodel._shouldSelectTarget(this.key) || viewmodel._shouldSelectTarget(`${this.key}${osName}`));
      const os = {
        name: osName,
        displayName: i18n.get(`Targeting_Device_OperatingSystem_${osName}`),
        parentName: this.name,
        CampaignBidId: viewmodel.options[`${this.key}${osName}CampaignBidId`],
        AdgroupBidId: viewmodel.options[`${this.key}${osName}AdgroupBidId`],
        originalCampaignBidAdjustmentValue: viewmodel.options[`${this.key}${osName}CampaignBidAdjustment`],
        originalAdgroupBidAdjustmentValue: viewmodel.options[`${this.key}${osName}AdgroupBidAdjustment`],
        selectedBidAdjustmentOption: ko.computed(() => {
          return this.selectedBidAdjustmentOption();
        }, this),
        bidAdjustmentValue: ko.computed(() => {
          return this.bidAdjustmentValue();
        }, this),
        isSelected,
        onClick: () => {
          if (!isSelected() && this.selectedOsCount() === 0) {
            isSelected(true);
          }
          viewmodel._countValidatedDevices();
          return true;
        },
      };

      if ((viewmodel.levelPrefix() === 'Campaign' && os.CampaignBidId > 0) ||
          (viewmodel.levelPrefix() === 'Adgroup' && os.AdgroupBidId > 0)) {
        this.selectedBidAdjustmentOption(helper.getSelectedBidAdjustmentOption(`${this.key}${osName}`, viewmodel.options, viewmodel.level, viewmodel.useCampaignSettings()));
        this.bidAdjustmentValue(helper.getBidAdjustmentValue(`${this.key}${osName}`, viewmodel.options, viewmodel.level, viewmodel.useCampaignSettings()));
      }
      return os;
    });
    this.osSelected = ko.computed(() => {
      if (this.selectedOsCount() === this.operatingSystems.length) {
        return i18n.get('Targeting_TargetOSAllOS');
      } else if (this.selectedOsCount() < this.operatingSystems.length && this.selectedOsCount() > 0) {
        return _.chain(this.operatingSystems)
          .filter((os) => {
            return os.isSelected();
          })
          .pluck('displayName')
          .value().join(',');
      } else {
        return '';
      }
    }, this);
  }
}

export default class ViewModel {
  constructor(options = {}) {
    this.options = options;
    this.level = options.level;
    this.useCampaignSettings = ko.observable(false);
    this.isForVNext = ko.observable(options.isForVNext);
    this.useCampaignSettings.subscribe(this._onCampaignSettingsCheckChange, this);
    this.showAdGroupOverrideInformation = ko.observable(false);
    this.devices = [];
    this.selectedDeviceCount = 0;
    this.levelPrefix = ko.computed(() => {
      return this.options.level === 'campaign' || this.useCampaignSettings() ? 'Campaign' : 'Adgroup';
    }, this);
    this._populatedevices();
  }
  _ifAnyAdgroupBidAdjustment(target) {
    let anyAdgroupBidAdjustment = false;

    if (this.options.scenario === 'adgroup-settings') {
      anyAdgroupBidAdjustment = target.AdgroupBidId > 0;
    }
    return anyAdgroupBidAdjustment;
  }
  _populatedevices() {
    let anyAdgroupBidAdjustment = false;

    _.each(targetConstants.rowKeys.Device, (deviceKey) => {
      const device = new Device({
        key: deviceKey,
        name: i18n.get(`DeviceType_${deviceKey}`),
        operatingSystems: targetConstants.osNames[deviceKey],
      }, this);

      this.devices.push(device);
      if (this.options.level === 'adgroup') {
        anyAdgroupBidAdjustment = anyAdgroupBidAdjustment || this._ifAnyAdgroupBidAdjustment(device);
        if (!anyAdgroupBidAdjustment) {
          anyAdgroupBidAdjustment = anyAdgroupBidAdjustment || _.some(device.operatingSystems, (os) => {
            return this._ifAnyAdgroupBidAdjustment(os);
          });
        }
      }
    });

    if (this.options.level === 'adgroup' && !anyAdgroupBidAdjustment &&
      this.options.showLevelToggle) {
      this.useCampaignSettings(true);
      this.showAdGroupOverrideInformation(this.options.fromSettingsGrid);
    } else if (this.selectedDeviceCount === 0) {
      this._selectAll();
    }
  }
  _onCampaignSettingsCheckChange() {
    _.each(this.devices, (device) => {
      const shouldSelectDevice = this._shouldSelectTarget(device.key);

      device.isSelected(false);//Reset the observable
      device.isSelected(shouldSelectDevice);
      device.selectedBidAdjustmentOption(helper.getSelectedBidAdjustmentOption(device.key, this.options, this.level, this.useCampaignSettings()));
      device.bidAdjustmentValue(helper.getBidAdjustmentValue(device.key, this.options, this.level, this.useCampaignSettings()));

      _.each(device.operatingSystems, (os) => {
        const shouldSelectOs = this._shouldSelectTarget(`${device.key}${os.name}`);

        os.isSelected(false);//Reset the observable
        os.isSelected(shouldSelectDevice || shouldSelectOs);
        if (shouldSelectOs) {
          device.selectedBidAdjustmentOption(helper.getSelectedBidAdjustmentOption(`${device.key}${os.name}`, this.options, this.level, this.useCampaignSettings()));
          device.bidAdjustmentValue(helper.getBidAdjustmentValue(`${device.key}${os.name}`, this.options, this.level, this.useCampaignSettings()));
        }
      });
    });
    if (this.selectedDeviceCount === 0) {
      this._selectAll();
    }
    this.showAdGroupOverrideInformation(false);
  }
  _selectAll() {
    _.each(this.devices, (device) => {
      device.isSelected(true);
      _.each(device.operatingSystems, (os) => {
        os.isSelected(true);
      });
    });
  }
  _shouldSelectTarget(key) {
    const useCampaignSettings = this.useCampaignSettings();

    if (this.options.scenario === 'creation-workflow') { //campaign-create scenario
      return true;
    } else if (this.options.scenario === 'adgroup-create') {
      return !useCampaignSettings || this.options[`${key}CampaignBidId`] > 0;
    } else if (this.options.scenario === 'campaign-settings') {
      return this.options[`${key}CampaignBidId`] > 0;
    } else {
      if (this.options.subScenario === 'targeting-settings-inherited-copy-over') {
        return this.options[`${key}CampaignBidId`] > 0;
      }

      return useCampaignSettings ? this.options[`${key}CampaignBidId`] > 0 : this.options[`${key}AdgroupBidId`] > 0;
    }
  }
  _getCriterion(id, deviceName, osName, bidAdjustment, isDelete) {
    const criterion = {
      Id: id,
      CriterionType: 'Device',
      Criterion: {
        Type: 'Device',
        DeviceCriterion: {
          DeviceName: deviceName,
        },
      },
    };

    if (bidAdjustment) {
      criterion.Criterion.BidAdjustment = bidAdjustment;
    }
    if (osName) {
      criterion.Criterion.DeviceCriterion.OSName = osName;
    }
    if (isDelete) {
      criterion.Status = 'Deleted';
    }
    return criterion;
  }
  _deleteCriterionWhenAppropriate(device, os, values) {
    const levelPrefix = this.levelPrefix();
    const target = os ? os : device;

    if (target[`${levelPrefix}BidId`] > 0) {
      if (!target.isSelected() ||
          (os && device.selectedOsCount() === device.operatingSystems.length) || //this is because if user selects os level targets and then checks at the device level, we need to delete the os levels targets
          (!os && device.selectedOsCount() < device.operatingSystems.length)) { //vise versa
        values.push(
          this._getCriterion(target[`${levelPrefix}BidId`],
            target.parentName ? target.parentName : target.name,
            target.parentName ? target.name : null,
            null, true));
        return true;
      }
    }
    return false;
  }
  _addOrUpdateCriterion(target, values) {
    const rowBidAdjustment = Number(target.bidAdjustmentValue()) * target.selectedBidAdjustmentOption();
    const levelPrefix = this.levelPrefix();

    let addEntry = false;
    const isSelected = target.isSelected();

    if (target[`${levelPrefix}BidId`]) {
      addEntry = isSelected && rowBidAdjustment !== target[`original${levelPrefix}BidAdjustmentValue`];
    } else {
      addEntry = isSelected;
    }

    if (addEntry) {
      values.push(this._getCriterion(
        target[`${levelPrefix}BidId`],
        target.parentName ? target.parentName : target.name,
        target.parentName ? target.name : null,
        rowBidAdjustment));
    }
  }
  _countValidatedDevices() {
    let valid = true;

    this.devices.forEach((deviceRow) => {
      if (deviceRow.error() !== '') {
        valid = false;
      }
    });
    if (this.options.onChange) {
      this.options.onChange(valid, this.getValues());
    }
  }
  _validateBid(device) {
    let isInRange = true;
    let isDecimal = true;
    let isNotEmpty = true;
    let isNonNegative = true;
    const rowBid = device.bidAdjustmentValue();

    isInRange = rowBid >= 0 &&
      (device.selectedBidAdjustmentOption() === targetConstants.bidAdjustmentIncreaseValue ?
        rowBid <= targetConstants.maximumBid.DeviceType_Smartphones :
        (device.name === 'Smartphones' && Number(rowBid) === 100) || rowBid <= targetConstants.minimumBid.DeviceType_Smartphones);
    isDecimal = parseInt(rowBid) === Number(rowBid);
    isNotEmpty = rowBid.toString().length > 0;
    isNonNegative = rowBid >= 0;

    const bidValid = isNotEmpty && isInRange && isDecimal && isNonNegative;

    if (bidValid) {
      device.error('');
    } else if (!isNotEmpty) {
      device.error(i18n.get('AdvancedTargeting_Error_BidValueMustNotBeEmpty'));
    } else if (!isDecimal || !isNonNegative) {
      device.error(i18n.get('Validation_InvalidBidAdjustment'));
    } else if (!isInRange) {
      const rawMessage = device.name === 'Smartphones' ? i18n.get('EnhancedCampaign_Mobile_Validation') : i18nApiError.get('Error_Campaign_API_InvalidDeviceTargetBidAdjustment');

      device.error(rawMessage.replace('{0}', targetConstants.minimumBid.DeviceType_Smartphones).replace('{1}', targetConstants.maximumBid.DeviceType_Smartphones));
    }
    this._countValidatedDevices();
    return bidValid;
  }
  setLevel(level) {
    this.options.level = this.level = level;
  }
  validate() {
    let isValid = true;

    _.each(this.devices, (device) => {
      isValid = isValid && this._validateBid(device);
    }, this);
    return isValid;
  }
  getValues() {
    let values = [];

    if (this.options.scenario === 'adgroup-create' && this.useCampaignSettings()) {
      return values;
    } else if (this.options.scenario === 'adgroup-settings' && this.useCampaignSettings()) { //delete existing adgroup targets when select use campaign setting
      _.each(this.devices, (device) => {
        if (device.AdgroupBidId > 0) {
          values.push(this._getCriterion(device.AdgroupBidId, device.name, null, null, true));
        } else {
          _.each(device.operatingSystems, (os) => {
            if (os.AdgroupBidId > 0) {
              values.push(this._getCriterion(os.AdgroupBidId, device.name, os.name, null, true));
            }
          });
        }
      });
      return values;
    }

    _.each(this.devices, (device) => {
      if (!this._deleteCriterionWhenAppropriate(device, null, values) &&
      device.selectedOsCount() === device.operatingSystems.length) { //Top level targets
        this._addOrUpdateCriterion(device, values);
      }
      _.each(device.operatingSystems, (os) => {
        if (!this._deleteCriterionWhenAppropriate(device, os, values) &&
        device.selectedOsCount() < device.operatingSystems.length) { // Os level targets
          this._addOrUpdateCriterion(os, values);
        }
      }, this);
    }, this);
    return values;
  }
  setData(updatingEntity) {
    if (updatingEntity.Id && !updatingEntity.errors) {
      const deviceName = updatingEntity.Criterion.DeviceCriterion.DeviceName;
      const osName = updatingEntity.Criterion.DeviceCriterion.OSName;
      let deviceToUpdate = _.find(this.devices, (device) => {
        return device.name === deviceName;
      });

      if (deviceToUpdate) {
        deviceToUpdate.error('');
        if (osName) {
          deviceToUpdate = _.find(deviceToUpdate.operatingSystems, (os) => {
            return os.name === osName;
          });
        }
      }
      if (deviceToUpdate) {
        if (updatingEntity.Status === 'Deleted') {
          deviceToUpdate[`${this.levelPrefix()}BidId`] = '';
        } else {
          deviceToUpdate[`${this.levelPrefix()}BidId`] = updatingEntity.Id;
        }
      }
    }
  }
  handleErrors(response) {
    const remainingErrors = [];
    const apiErrors = getBulkApiErrors(response.errors);
    const criterionEntities = this.options.level === 'campaign' ?
      response.entity.CampaignCriterions : response.entity.AdGroupCriterions;

    _.map(response.errors, (error) => {
      const errorEntity = _.find(criterionEntities, (criterion) => {
        return criterion['Client Id'] === error['Client Id'];
      });

      if (errorEntity) {
        const failedDevice = _.find(this.devices, (device) => {
          return errorEntity.Criterion.DeviceCriterion && device.name === errorEntity.Criterion.DeviceCriterion.DeviceName;
        });

        if (failedDevice) {
          const errorWithMes = _.find(apiErrors, (apiError) => {
            return apiError.code === error.Error;
          });

          failedDevice.error(errorWithMes.message);
        } else {
          remainingErrors.push(error);
        }
      } else {
        remainingErrors.push(error);
      }
    });
    return remainingErrors;
  }
}
